import {Component, Inject } from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';


@Component({
  selector: 'lookupFailDialog',
  templateUrl: 'lookupFailDialog.html',
})
export class LookupFailDialog {
    public orderId: string = '';
    constructor(@Inject(MAT_DIALOG_DATA) public data: {orderId?: string}) {
      console.debug("Could not find order:", this.orderId);
    }

    close(){
    }
}
